<script setup lang="ts">
/**
 * BrandTag — compact SUKI / BBQ badge preceding branch-name entries.
 *
 * Same-mall Suki/BBQ branches share identical display names, so every
 * branch entry carries a brand tag (PO decision 2026-08-19: uppercase
 * SUKI / BBQ only — no "Lucky" prefix). Resolves from the brand code
 * first (fuzzy: lucky_suki / suki / lucky-suki all work), then from the
 * branch-name prefix. Renders nothing when neither resolves.
 */
import { computed } from 'vue';
import { brandShortTag, brandTagFromName } from '@/lib/brand';

const props = defineProps<{
  code?: string | null;
  name?: string | null;
}>();

const label = computed(() => brandShortTag(props.code) || brandTagFromName(props.name));
</script>

<template>
  <span v-if="label" class="brand-tag">{{ label }}</span>
</template>

<style scoped>
.brand-tag {
  display: inline-block;
  margin-right: 0.3rem;
  padding: 0.05rem 0.35rem;
  border-radius: var(--radius-badge);
  background: var(--surface-2);
  border: 1px solid var(--line);
  color: var(--text-dim);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  vertical-align: baseline;
  white-space: nowrap;
}
</style>
